<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<div>
						<b-tabs content-class="mt-3" align="center">
							<b-tab :title="$t('global.operationTracking')">
								<b-form @submit.prevent="() => updateLists() ">
									<b-row>
										<div class="col-md-3">
											<h2 class="inline-heading">
												{{$t('global.operationTracking')}}
											</h2>
										</div>
										<b-form-group class="col-md-3" :label="$t('bookings.servicesFrom')">
											<b-form-datepicker
												:locale="$root.store.state.currentUser.lang"
												reset-button
												size="sm"
												v-model="filters.pickupStartDate"
											/>
										</b-form-group>
										<b-form-group class="col-md-3" :label="$t('bookings.servicesTo')">
											<b-form-datepicker
												:locale="$root.store.state.currentUser.lang"
												reset-button
												size="sm"
												v-model="filters.pickupEndDate"
											/>
										</b-form-group>
										<b-form-group class="col-md-1 pt-3">
											<b-button type="submit" variant="primary" >{{$t('global.search')}}</b-button>
										</b-form-group>
									</b-row>
								</b-form>
								<!-- <b-row>
									<b-col>
										<h5>
											<b-badge
												v-for="(aux,i) in $root.auxVars.transportServiceStatusOpts"
												:key="i"
												:variant="aux.class"
												class="mr-2"
												size=""
												>
												{{$t(`bookings.serviceStatusOpts.${aux.value}`)}}
											</b-badge>
										</h5>
									</b-col>s
								</b-row> -->
								<br>
								<div v-for="(trackingStatus,_i) in ['pending','onWayToPickup','atPickup','onWayToDropoff','finished','noShow']" :key="_i">
									<h3>{{$t(`bookings.trackingStatusOpts.${trackingStatus}`)}}</h3>
									<AjaxTableReservations
										:id="`reservations-lists-${trackingStatus}`"
										:ref="`reservations-lists`"
										stacked="lg"
										show-select-all
										hide-pagination
										:filters="filtersCleanTrackingStatus(trackingStatus)"
										:columns="modelColumns"
										:sort-by.sync="sortBy"
										:sort-desc.sync="sortDesc"
										resource="transport-services"
										responsive
										:res-view="resView"
									/>
								</div>
							</b-tab>
							<b-tab :title="$t('rto.drivers')" lazy>
								<KeepAlive>
									<DriverLocationModule/>
								</KeepAlive>
							</b-tab>
						</b-tabs>
					</div>
				</div>
			</div>
			<Single
				ref="single"
				:model-id.sync="modelId"
				:show.sync="showSingleModal"
				@onCopyRes="copyCurrentRes"
				operated-by="supplier"
			/>
			<vue-snotify></vue-snotify>
		</MainLayout>
</template>
<script>
import MainLayout from '../layout/MainLayout.vue'
import Single from './Single'
import AjaxTableReservations from './AjaxTableReservations'
import Pusher from '../../../plugins/pusher.js'
import DriverLocationModule from './modules/DriversLocation.vue'

export default {
		components: { MainLayout, Single, AjaxTableReservations,DriverLocationModule },
		data(){
			const now = this.$moment().format("YYYY-MM-DD")
			let defaultFilters = {
				id:'',
				clientFullName:'',
				destination:[],
				salesChannel:[],
				supplier:[],
				airport:[],
				serviceType:[],
				pickupStartDate : now,
				pickupEndDate : now,
				creationStartDate:'',
				creationEndDate:'',
				cancelationStartDate:'',
				cancelationEndDate:'',
				trip:0,
				contactStatus:0,
				salesChannelReference: '',
				supplierReference: '',
				containsEmail: '',
				clientEdited: '',
				clientConfirmed: '',
				showAdvancedOptions: false,
				pickupDatetimeConfirmed:null,
				fromPointOfSale:null,
				placesWithoutCoordinates:null,
				supplierPriceTotalEmpty:null,
				// status:[{value:'active',text:this.$t(`bookings.serviceStatusOpts.active`)}],
				status:[],
				driverAssigned:null,
				supplierConfirmation:'accepted',
				trackingStatus:null,
			}
			return {
				showAssignDriverUnit:false,
				itemsAssigned:[],
				showFilters:false,
				modelId:-1,
				showSingleModal:false,
				exportLoading:false,
				showSelectAll:true,
				sortBy: 'reservationId',
				sortDesc: true,
				filters : {...defaultFilters},
				defaultFilters : {...defaultFilters},
				modelColumns : [
					{key:'reservationId',label:'Res ID', tdClass:'one-line-fix'},
					{key:'clientName',label: this.$t('bookings.client')},
					{key:'pickup',label:'Pickup'},
					{key:'dropoff',label:'Dropoff'},
					{key:'trip',label:this.$t('bookings.trip')},
					{key:'pickupDatetime',label: this.$t('bookings.pickupDatetime'),sortable:true, tdClass:'one-line-fix'},
					{key:'supplierServiceType.name',label:this.$t('bookings.serviceType')},
					// {key:'trackingStatus',label:this.$t('bookings.trackingStatus')},
					{key:'userDriver',label:this.$t('bookings.driver')},
					{key:'transportUnit',label:this.$t('bookings.transportUnit')},
					{key:'actions',label:this.$t('bookings.actions')},
					// {key:'save',label:this.$t('global.save')},
				],
				pusherInstance:null
			}
		},
		computed: {
			pickupConfirmedOpts(){
				// eslint-disable-next-line
				this.$root.$i18n.locale
				return [
					{value:null,text:this.$t('global.all')},
					{value:true,text:this.$t('bookings.confirmed')},
					{value:false,text:this.$t('bookings.noConfirmed')}
				]
			},
			trackingStatusOpts(){
				// eslint-disable-next-line
				this.$root.$i18n.locale
				return [
					{value:null,text:this.$t('global.all')},
					{value:'pending',text:this.$t('bookings.trackingStatusOpts.pending')},
					{value:'onWayToPickup',text:this.$t('bookings.trackingStatusOpts.onWayToPickup')},
					{value:'atPickup',text:this.$t('bookings.trackingStatusOpts.atPickup')},
					{value:'onWayToDropoff',text:this.$t('bookings.trackingStatusOpts.onWayToDropoff')},
					{value:'finished',text:this.$t('bookings.trackingStatusOpts.finished')},
					{value:'noShow',text:this.$t('bookings.trackingStatusOpts.noShow')},
				]
			},
			filtersClean(){
				return {
					id:  this.filters.id,
					clientFullName:  this.filters.clientFullName,
					destination:  this.filters.destination.map(aux => aux.value),
					airport:  this.filters.airport.map(aux => aux.value),
					serviceType:  this.filters.serviceType.map(aux => aux.value),
					pickupStartDate: this.filters.pickupStartDate,
					pickupEndDate: this.filters.pickupEndDate,
					creationStartDate: this.filters.creationStartDate,
					creationEndDate: this.filters.creationEndDate,
					cancelationStartDate: this.filters.cancelationStartDate,
					cancelationEndDate: this.filters.cancelationEndDate,
					trip: this.filters.trip,
					status: this.filters.status.map(aux => aux.value),
					salesChannelReference: this.filters.salesChannelReference,
					pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
					supplierReference: this.filters.supplierReference,
					driverAssigned: this.filters.driverAssigned,
					trackingStatus:this.filters.trackingStatus,
				}
			},
			destinationsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.destinationsOpts}]
			},
			airportsOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.airportsOpts}]
			},
			statusOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.transportServiceStatusOpts.map(opt => ({value:opt.value,text:this.$t(`bookings.serviceStatusOpts.${opt.value}`)}))}]
			},
			tripOpts(){
				let aux = [...this.$root.auxVars.tripOpts]
				aux.unshift({value:0,text: this.$t('global.all')})
				return aux
			},
			serviceTypesOpts(){
				return [{group:'SELECT ALL',options: this.$root.auxVars.serviceTypesOpts}]
			},
			statusLabels(){
				let vars = this.$root.auxVars.transportServiceStatusOpts
				let opts = {}
				for (let i = 0; i < vars.length; i++) {
					opts[vars[i].value] = vars[i].text
				}
				return opts
			},
			serviceStatusVariants(){
				let aux = {}
				this.$root.auxVars.transportServiceStatusOpts.map(status => {
					aux[status.value] = status.class
				})
				return aux
			},
			supplierId(){
				return this.$root.store.state.currentSystem.system.id
			}
		},
		methods:{
			filtersCleanTrackingStatus(trackingStatus){
				let filters = {...this.filtersClean}
				filters.trackingStatus = trackingStatus
				return filters
			},
			copyCurrentRes(){
				const aux = this.modelId
				this.modelId = -1
				this.$refs.single.copyFromId(aux)
			},
			updateLists(){
				this.$refs['reservations-lists'].forEach(list => {
					this.$root.$emit('bv::refresh::table', list.$attrs.id)
					// list.refresh()
				})
				// this.$root.$emit('bv::refresh::table', 'reservations-index-onWayTopPickup')
			},
			// onSave(item){
			// 	item.loading = true
			// 	this.$root.api.put(`/transport-services-operation/${item.id}`,{
			// 		transportUnitId : item.transportUnitInput.value,
			// 		userDriverId : item.userDriverInput.value,
			// 	}).then(() => {
			// 		item.transportUnit = { id: item.transportUnitInput.value, title: item.transportUnitInput.text }
			// 		item.userDriverId = { id: item.userDriverInput.value, firstName: item.userDriverInput.text }
			// 		item.loading = false
			// 		this.$root.showAlert('Servicio actualizado con éxito')
			// 	});
			// },
			resView(item){
				this.modelId = item.reservationId
				this.showSingleModal = true
			},
		},
		mounted(){
			this.pusherInstance = Pusher.getInstance()
			this.pusherInstance.unsubscribe(`private-supplier-${this.supplierId}`)
			let channel = this.pusherInstance.subscribe(`private-supplier-${this.supplierId}`);
			channel.bind("status-changed", (data) => {
				let alertMsj     = this.$t("alerts.trackingStatusChanged",{
					serviceNumber:data.serviceNumber,
					trackingStatus: this.$t(`bookings.trackingStatusOpts.${data.trackingStatus}`)
				})
				this.$root.showAlert(alertMsj);
				this.updateLists()
			});


			// this.$root.auxVars.loadResourcesOpts(this,['serviceTypesOpts','airportsOpts','destinationsOpts']);
		},
		destroyed(){
			if(this.pusherInstance !== null){
				this.pusherInstance.unsubscribe(`private-supplier-${this.supplierId}`)
			}
		},
		watch:{
		}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style >
	.multiselect__tags{
		max-height: 150px;
		overflow-y: auto;
		overflow-y: auto;
	}
	.active-filter{
		border: 2px solid #021D3E;
	}
	.snotifyToast__title {
		font-size: 1.5em;
	}
	.inline-heading {
		display: inline;
	}
	.inline-button {
		margin-bottom: 10px;
	}
	.btn-middle {
		margin-right: 8px;
	}
</style>
